/**
 * Background color options for the MusicCard component.
 * Treat this file as an enum.
 * @module musicCardColorOptions
 * @category MusicSelection
 * @author Dan Levy <danlevy124@gmail.com>
 */

/**
 * Secondary blue color
 * @type {string}
 */
export const SECONDARY_BLUE = "secondaryBlue";

/**
 * Green color
 * @type {string}
 */
export const GREEN = "green";

/**
 * Primary blue color
 * @type {string}
 */
export const PRIMARY_BLUE = "primaryBlue";

/**
 * Orange color
 * @type {string}
 */
export const ORANGE = "orange";

/**
 * Tertiary blue color
 * @type {string}
 */
export const TERTIARY_BLUE = "tertiaryBlue";

/**
 * Red color
 * @type {string}
 */
export const RED = "red";
